/* eslint-disable jsx-a11y/anchor-is-valid */
import NotificationItems from 'components/molecules/notification_items';
import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import Pagination from 'components/atoms/pagination';
import {
  getAllUnreadNotificationsCampaigns,
  getAllUnreadNotificationsDocuments,
  getAllUnreadNotificationsManagementBiddings,
  getAllUnreadNotificationsUpdatedBiddings,
} from 'store/modules/new_notification_store/actions';
import { markAsReadNotification } from 'store/modules/notification_store/actions';
import Loader from 'components/atoms/loader';
import { NotificationRequestTypes } from 'store/modules/new_notification_store/types';

const Notifications = () => {
  const dispatch = useDispatch();
  const [notificationList, setNotificationList] = useState<any>([]);
  const [notificationType, setNotificationType] = useState<Array<string>>([]);
  const [totalNotification, setTotalNotification] = useState<number>(0);
  const [loading, setLoading] = useState<boolean>(true);
  const [currentPage, setCurrentPage] = useState<number>(1);

  const paginate = (currentPage = 1) => {
    if (currentPage) {
      setCurrentPage(currentPage);
    }
  };

  useEffect(() => {
    document.title = 'Notificações - ConLicitação';
  }, []);

  useEffect(() => {
    const loadNotifications = async () => {
      try {
        const updatedBiddingsResponse = await dispatch(
          getAllUnreadNotificationsUpdatedBiddings({ page: currentPage, per_page: 50 }),
        );
        const managementBiddingsResponse = await dispatch(
          getAllUnreadNotificationsManagementBiddings({ page: currentPage, per_page: 50 }),
        );
        const campaignsResponse = await dispatch(
          getAllUnreadNotificationsCampaigns({ page: currentPage, per_page: 50 }),
        );
        const documentsResponse = await dispatch(
          getAllUnreadNotificationsDocuments({ page: currentPage, per_page: 50 }),
        );

        const responses = [
          updatedBiddingsResponse,
          managementBiddingsResponse,
          campaignsResponse,
          documentsResponse,
        ];

        const list: any[] = [];
        const types: string[] = [];

        responses.forEach((response: any) => {
          const { notification_type, notifications } = response.data;

          if (Array.isArray(notification_type)) {
            types.push(...notification_type);
          } else {
            types.push(notification_type.toLowerCase());
          }

          list.push(...notifications);
        });

        setNotificationList(list);
        currentPage === 1 && setTotalNotification(list?.length);
        setNotificationType(types);
        setLoading(false);
      } catch (error) {
        console.error('Erro ao carregar notificações:', error);
      }
    };

    loadNotifications();
  }, [dispatch, currentPage]);

  const handleClickarkAllAsRead = () => {
    dispatch(markAsReadNotification(notificationType));
    dispatch({
      type: NotificationRequestTypes.MARK_ALL_AS_READ,
    });
  };

  return (
    <div className="page-container p-4">
      <div className="container mt-3">
        <div className="row">
          <div className="col-md-12">
            {loading ? (
              <Loader />
            ) : (
              <>
                <div className="row mb-4">
                  <div className="col-md-9">
                    <h4 className="font-weight-bold">Notificações</h4>
                  </div>
                  <div className="col-md-3">
                    <a
                      className="float-right mark-as-read"
                      href="#"
                      onClick={() => handleClickarkAllAsRead()}
                    >
                      Marcar todas como lidas
                    </a>
                  </div>
                </div>
                <div className="row mb-8">
                  <div className="col-md-12">
                    <div className="list-group list-group-flush mb-4">
                      {notificationList?.map((notification: any) => (
                        <NotificationItems
                          key={`notification_index_item_${notification.id}`}
                          notification={notification}
                        />
                      ))}
                    </div>
                    <Pagination
                      postsPerPage={50}
                      totalPosts={totalNotification}
                      paginate={paginate}
                      currentPage={currentPage}
                      firstAndLastPage
                    />
                  </div>
                </div>
              </>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};
export default Notifications;
